export const nav = () => {

  const $body = $('body');
  const $nav = $('.js-nav');
  const btnToggleNav = '.js-toggle-nav';

  let isNavToggled = false;

  const init = () => {
    bind();
  };

  const observer = new IntersectionObserver(
    ([e]) => e.target.toggleAttribute('stuck', e.intersectionRatio < 1),
    {threshold: [1]}
  );

  const bind = () => {
    $body.on('click', btnToggleNav, (e) => {
      e.preventDefault();
      toggle();
    });

    observer.observe(document.querySelector('.js-nav'));

  };

  const toggle = () => {

    if (isNavToggled) {
      $nav.attr('data-state','closed');
      $body.attr('data-menu-open','false');
    } else {
      $nav.attr('data-state','open');
      $body.attr('data-menu-open','true');
    }

    isNavToggled = !isNavToggled;

  };

  init();
};
